<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row relative">
                <span class="hideinmob">
                    <div class="d-flex shortedit" v-if="($gate.isCeo()) && $gate.loginUser().is_isinitialstep==1">
                        <div><img src="./../../img/menus/schoolsystem.png" alt="Menu"></div>
                        <router-link :to="'/setuporg'" v-if="$gate.isCeo()"> <div class="pt-3 ml-2 text-primary pointer"><i class="fa fa-edit"></i> <u>Organization</u></div></router-link>
                    </div>
                </span>
                   <div class="col-md-12" v-if="$gate.loginUser().uic_validate==0 && $gate.loginUser().is_inquiry==0">
                       <div class="vh-100 pt-4 actualpaddinghm d-flex justify-content-center align-items-center">
                        <div class="p-4 w-25 bg-light text-left">
                                <div class="text-danger pt-1 pb-1">{{msg}}</div>
                                <div class="form-group text-left">
                                    <label for="exampleInputEmail1">Enter Your UIC</label>
                                    <input type="text" v-model="uic" class="form-control" id="exampleInputEmail1">
                                </div>
                                <button type="submit" class="btn btn-primary" @click="validateUIC()">Submit</button>
                            </div>
                       </div>
                    </div>
                    <!-- <div class="col-12 col-sm-12 col-md-12" v-if="$gate.loginUser().uic_validate==1 && $gate.loginUser().is_inquiry==0">
                       <div class="home-vh d-flex justify-content-center align-items-center">
                        <div><img src="./../../img/logo_landing.png" alt="The Logo" class="w-100-m"></div>
                        </div>
                        <div class="d-flex text-primary mt-2">
                            <div>Update Organization</div>
                            <div class="ml-5">Skip</div>
                        </div>
                   </div> -->
                  
                   <div class="container vertical-center" id="partI" v-if="$gate.loginUser().uic_validate==1 && $gate.loginUser().is_inquiry==0">
                    <div class="row text-center" v-if="!this.isSkipDiv && $gate.loginUser().is_isinitialstep==0">
                        <div class="col-md-12">
                        <img src="./../../img/logo_landing.png" alt="The Logo" class="w-100-m">
                            <div class="d-flex justify-content-center mt-4" v-if="($gate.isCeo() || $gate.isPrincipal())">
                                <div class="ft-18 text-primary pointer" @click="isSchoolOrgProf=true" v-if="($gate.isCeo()) && $gate.loginUser().is_isinitialstep==0"><u>Setup Organization</u></div>
                                <router-link :to="'/setuporg'" v-if="$gate.isCeo()"> <div class="ft-18 text-primary pointer" v-if="($gate.isCeo()) && $gate.loginUser().is_isinitialstep==1"><u>Update Organization</u></div></router-link>
                               
                                <router-link :to="'/setupschool'" v-if="$gate.isPrincipal()"><div class="ft-18 text-primary pointer" @click="updateMyStep(1)"><u>Update School</u></div></router-link>
                                <div class="ml-5 ft-18 pointer" @click="updateMyStep('skip')"><u>Skip</u></div>
                           </div>
                         </div> 
                    </div> 


                <div class="row" v-if="$gate.loginUser().uic_validate==1 && $gate.loginUser().is_inquiry==0 && this.isSkipDiv && ($gate.loginUser().is_isinitialstep==0)">
                    <div class="col-md-12 text-center mb-2">
                        <img src="./../../img/logo_landing.png" alt="The Logo">
                        </div>
              <div class="col-md-12 dashfav" v-if="menus.length>0">
                <div class="row" v-if="menus.length>0">
                <div class="col-sm-2 new-landing-avtar menus" v-for="item in menus">
                    <div class="p-2 topmenuhover contentdiv">
                        <router-link :to="'/'+item.params" class="nav-link pointer"> <div class="content-overlay"></div></router-link>
                        <img :src="'/images/menu/'+item.icon" alt="Menu" class="menu-img" @click="getRoute()">
                        <div class="land-menu-name" @click="getRoute()"><div>{{ item.name }}</div></div>
                        <div class="content-details fadeIn-bottom" >
                            <div v-if="item.editing =='false'" >
                                <img v-tooltip="'Add to favorite'" src="./../../img/menus/heart.png" alt="Menu" class="iconfav pointer" @click="favFun(1,item.id,item)">

                               
                                        </div>
                                        <div v-else>
                                <!-- <img src="./../../img/menus/unheart.png" alt="Menu" class="iconfav pointer" @click="favFun(0,item.id,item)"> -->

                                            
                                            </div>


                           
                        </div>
                    </div>
                    </div>
                </div>
                <div class="row" v-else>
                <div class="col-sm-12 p-5 text-center ft-16">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
                </div> 
                <div class="col-sm-12">
                    <div class="d-flex justify-content-center  mt-2">
                            <div class="text-primary ft-16"><u><router-link :to="'/setuporg'" v-if="$gate.isCeo()">Update Organization</router-link></u></div>
                            <div class="ml-5 pointer ft-16" @click="isSkipDiv=false"><u>Back</u></div>
                        </div>
                </div>
            </div>  
            <div class="row" v-if="$gate.loginUser().uic_validate==1 && $gate.loginUser().is_inquiry==0 &&  ($gate.loginUser().is_isinitialstep==1)">
                    <div class="col-md-12 text-center mb-2">
                        <span class="hideindesk">
                        <div class="d-flex justify-content-center" v-if="($gate.isCeo()) && $gate.loginUser().is_isinitialstep==1">
                            <div><img src="./../../img/menus/schoolsystem.png" alt="Menu"></div>
                            <div class="pt-3 ml-2 text-primary pointer"><router-link :to="'/setuporg'"><i class="fa fa-edit"></i> <u>Organization</u></router-link></div>
                        </div>
                       
                    </span>
                    <span class="hideinmob"> <img  src="./../../img/logo_landing.png" alt="The Logo"></span>
                        </div>
              <div class="col-md-12 dashfav" v-if="menus.length>0">
                <div class="row" v-if="menus.length>0">
                <div class="col-md-2 col-sm-3 col-4 new-landing-avtar menus" v-for="item in menus">
                    <div class="p-2 topmenuhover contentdiv">
                        <router-link :to="'/'+item.params" class="nav-link pointer"> <div class="content-overlay"></div></router-link>
                        <img :src="'/images/menu/'+item.icon" alt="Menu" class="menu-img" @click="getRoute()">
                        <div class="land-menu-name" @click="getRoute()"><div>{{ item.name }}</div></div>
                        <div class="content-details fadeIn-bottom" >
                            <img v-tooltip="'Remove from favorite'" src="./../../img/menus/unheart.png" alt="Menu" class="iconfav pointer" @click="favFun(0,item.id,item)" v-if="$gate.loginUser().is_isinitialstep==1"> 
                        </div>
                    </div>
                    </div>
                </div>
                <div class="row" v-else>
                <div class="col-sm-12 p-5 text-center ft-16">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
                </div> 
            </div> 
                </div> <!-- container -->

                <div class="col-12 col-sm-12 col-md-12" v-if="$gate.loginUser().is_inquiry==1">
                       <div class="d-flex flex-column justify-content-center align-items-center vh-100">
                        <i class="fa fa-check main-content__checkmark ft-30" id="checkmark"></i>
                        <h2>Thank you for submitting your inquiry </h2>
                        <p>You will get your UIC , once approve your inquiry</p>
                    </div>
                </div>
             </div>
          </div>
          <transition name="modal" v-if="isSchoolOrgProf">
            <div class="modal-mask">
            <div class="modal-wrapper lg">
                <div class="modal-container">
                <div class="modal-header">
                    <slot name="header">
                    <div class="d-flex w-100">
                        <div class="ft-18 wt-6">
                        School Organization Profile Setting
                        </div>
                        <div class="ml-auto">
                        <i @click="isSchoolOrgProf=false,updateMyStep(1)" class="fas fa-times-circle pointer ft-24"></i>
                        </div>
                    </div>
                    </slot>
                </div>
                <slot name="body">
                    <div class="modal-body"><InfoOrg :editItem="schoolSystemInfo" v-if="schoolSystemInfo"></InfoOrg></div>
                    
                    </slot>
                </div>
            </div>
            </div>
        </transition>
        <transition name="modal" v-if="isProfilePage">
            <div class="modal-mask">
            <div class="modal-wrapper sm">
                <div class="modal-container">
                <div class="modal-header">
                    <slot name="header">
                    <div class="d-flex w-100">
                        <div class="ft-18 wt-6">
                        Profile Setting
                        </div>
                        <div class="ml-auto">
                        <i @click="isProfilePage=false" class="fas fa-times-circle pointer ft-24"></i>
                        </div>
                    </div>
                    </slot>
                </div>
                <slot name="body">
                    <profilepage></profilepage>
                    </slot>
                </div>
            </div>
            </div>
        </transition>
        <transition name="modal" v-if="isDailyQuestionPop">
            <div class="modal-mask">
            <div class="modal-wrapper sm">
                <div class="modal-container">
                <div class="modal-header">
                    <slot name="header">
                    <div class="d-flex w-100">
                        <div class="ft-18 wt-6">
                        Daily Questions
                        </div>
                        <div class="ml-auto">
                        <i @click="isDailyQuestionPop=false" class="fas fa-times-circle pointer ft-24"></i>
                        </div>
                    </div>
                    </slot>
                </div>
                <slot name="body">
                    <dailyQuestionPop @submitted-question="studentDailyQuestions()"></dailyQuestionPop>
                    </slot>
                </div>
            </div>
            </div>
        </transition>
    </section>
</template>

<script>
    export default {
        components: {
           InfoOrg: () => import("./schoolsystem/edit.vue"),
           profilepage: () => import("./Profile.vue"),
           dailyQuestionPop: () => import("./ExamsDailyQuestions/studentQuestion.vue"),
        },
        data () {
            return {
                isDailyQuestionPop: false,
               uic:'',
               msg:'' ,
               isProfilePage:false,
               schoolSystemInfo:null,
               schoolOrgInfo:null,
               isSchoolOrgProf:false,
               isSkipDiv:false,
               menus:[],
            }
        },
        created() {
            //this.showMenus();
           this.$eventHub.$on("successfullyprofilesubmitted", () => {
                this.isProfilePage=false;
            });
            this.$eventHub.$on("successSchoolfullyprofilesubmitted", () => {
                this.updateMyStep(1);
            });
            this.$eventHub.$on("successfullyssedited", () => {
                this.isSchoolOrgProf=false;
             });
            this.$eventHub.$on("cancelallformbtn", () => {
                  this.isSchoolOrgProf=false;
             });
             this.$eventHub.$on("successfullyaddedmenutofav", () => {
                if(this.$gate.loginUser().is_isinitialstep==1){
                this.showFavMenus();
            }else{
                this.showMenus();
            }
             });
        },
        mounted(){
            if (this.$gate.isStudent()) {
                    this.getStudentDailyTotalQuestion();
                }
            if(this.$gate.isCeo()){
                this.showSchoolOrg();
            }
            if(this.$gate.loginUser().is_profileupdatecomplete==0 && this.$gate.loginUser().uic_validate==1){
                this.isProfilePage=true;
             }else{
                this.isProfilePage=false;
            }
            if(this.$route.params.ic==1){
                this.isSkipDiv=true;
            }
            if(this.$gate.loginUser().is_isinitialstep==1){
                this.showFavMenus();
            }else{
                this.showMenus();
            }
            
            //console.log(this.$route.params.ic)
        },
        methods: {
            getStudentDailyTotalQuestion() {
                axios.get(this.$gate.BaseUrl()+'api/student/daily/total/question/').then(response => {
                    if (response.data.length > 0) {
                        this.isDailyQuestionPop = true;
                    }
                });
            },
            studentDailyQuestions() {
                this.isDailyQuestionPop = false;
            },
            validateUIC(){
                this.msg='';
              axios.post(this.$gate.BaseUrl()+'api/validateuic',{user_id:this.$gate.loginUser().id,uic:this.uic})
                .then((response)=>{
                    if(response.data==1){
                        Toast.fire({
                                icon: 'success',
                                title: 'UIC has been successfully Validate'
                        });
                        //this.$router.push({path: '/profile'});
                        window.location.href = this.$gate.BaseUrl()+'dashboard';
                    }else{
                        this.msg='Incorrect UIC Code'
                    }
                    
                    console.log(response.data)
                   
                })
                .catch(()=>{ })
            },
            updateMyStep(step=0){
                if(step=='skip'){
                       this.isSkipDiv=true;
                    }else{
                      this.updateMyStepByConfig(step);
                    }
                },
            updateMyStepByConfig(step=0){
                axios.get(this.$gate.BaseUrl()+"api/updatestep",{params:{step:step}})
                .then(response => {
                    var url = window.location.pathname;
                    window.location.href = this.$gate.BaseUrlWithoutSlash()+url;
                    if(this.$gate().isCeo){
                            this.$router.push('/setuporg');
                        }
                        if(this.$gate().isPrincipal){
                            this.$router.push('/setupschool');
                        }
                    

                 }).catch(error => {console.log(error) }).finally(() => this.loading = false)
                },
                loadSchoolSystemInfo(){
                var url = this.$gate.BaseUrl()+"api/schoolsystem/info/"+ this.schoolOrgInfo.uuid
                 axios.get(url).then(({ data }) => (this.schoolSystemInfo = data.data));
            },
            
             loadSchoolSystemInfo(){
                var url = this.$gate.BaseUrl()+"api/schoolsystem/info/"+ this.schoolOrgInfo.uuid
                 axios.get(url).then(({ data }) => (this.schoolSystemInfo = data.data));
            },
            showSchoolOrg(){   
                this.schoolOrgInfo=null; 
                axios.get(this.$gate.BaseUrl()+"api/showschorg/"+this.$gate.loginUser().current_school_org)
                .then(response => {
                    this.schoolOrgInfo=response.data.data;
                    if(this.schoolOrgInfo !=null){
                        this.loadSchoolSystemInfo();
                    }
                 })
             },
             showMenus(){   
                axios.get(this.$gate.BaseUrl()+"api/menu")
                .then(response => {
                    this.menus=response.data.data;
                 })
             },
             showFavMenus(){   
                axios.get(this.$gate.BaseUrl()+"api/favmenu")
                .then(response => {
                    this.menus=response.data.data;
                 })
             },
             favFun(type,id,item){
              if(type==1){
                item.editing = true;
              }else{
                item.editing = false;
              }
              axios.post(this.$gate.BaseUrl()+'api/fav',{type:type,id:id})
                                .then((response)=>{
                                    this.$eventHub.$emit("successfullyaddedmenutofavfromdash");
                                   if(type==1){
                                    this.showMenus();
                                   }else{
                                    this.showFavMenus();
                                   }
                                }).catch((data)=> {});
             },
        }
    }
</script>
<style scoped>
#partI{height: 70vh;}
#part2{height: 30vh;}

.vertical-center {
display: -webkit-box;
display: -moz-box;
display: -ms-flexbox;
display: -webkit-flex;
display: flex; 
  
-webkit-box-align : center;
-webkit-align-items : center;
-moz-box-align : center;
-ms-flex-align : center;
align-items : center;
  
justify-content : center; /*only if you have a small text as ,example I' otherwise for long text you don't need this line*/
}
.shortedit{
    position: absolute;
}
.dashfav{
    max-height: 248px;
    overflow-y: auto;
}
.iconfav {
  width: 20px;
}
</style>
